import { Capacitor } from '@capacitor/core';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Toast } from 'antd-mobile';
import axios from 'axios';
import JSZip from 'jszip'; // 浏览器环境下使用 JSZip
import { _req, bizBaseUrl } from 'services/request';

export const isNative = (): boolean => {
  return getPlatform() === 'native';
};

export const getPlatform = () => {
  // Capacitor.getPlatform();// -> ‘web’、‘ios’ 或 ‘android’
  // Capacitor.platform// -> 'web'、'ios' 或 'android' （已弃用）
  // Capacitor.isNative// -> true 或 false (已弃用)
  // Capacitor.isNativePlatform// -> 不准确 (不要用)
  let platform = Capacitor.getPlatform();
  switch (platform) {
    case 'android':
    case 'ios':
      platform = 'native'; // 如果是原生环境
      break;
    case 'web':
      platform = 'browser'; // 如果是浏览器环境
      break;
    default:
      platform = 'unknown'; // 默认返回未知
  }
  // console.log('当前环境: ' + platform);
  return platform;
};
